// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3OxfF","right":"Footer_right__28t-r","buttons":"Footer_buttons__3Zq4C"};